import React from "react";
import { Outlet } from "react-router-dom";
import { Box, CssBaseline, Toolbar, Drawer, AppBar } from "@mui/material";
import NavigationBar from "./NavigationBar";
import SidebarNavigation from "./SidebarNavigation";

const drawerWidth = 240;

const WithSidebarAndNavigationBar: React.FC = () => {
  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <NavigationBar />
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <SidebarNavigation />
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "background.default",
          p: 3,
          mt: "64px", // Height of the AppBar
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default WithSidebarAndNavigationBar;
